import { useUpdateAuthState } from "@/auth";
import { SessionScheduling } from "@/components";

function PaymentPage() {
  useUpdateAuthState();
  return <SessionScheduling />;
}

export { PaymentPage };
